<template>
    <v-dialog
        persistent
        v-model="open"
        max-width="700px"
    >
        <v-card>
            <v-card-title>
                Anzahl Paketaufkleber
            </v-card-title>
            <v-card-text class="pt-6 pb-2">
                <v-form v-model="valid">
                    <v-text-field type="number" v-model="anzahl" label="Anzahl"
                                  :rules="[rules.loanMin, rules.loanMax, rules.integer]" step="1"
                                  min="1" max="20"/>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn @click="close" plain>Abbrechen</v-btn>
                <v-btn @click="save" color="aprocon-blue-light" :disabled="!valid" depressed>Ok
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';

import {globalEventBus} from "@/main";

@Component({components: {}})
export default class AnzahlDialog extends Vue {

    private valid: boolean = true;
    private rules: any = {
        loanMin: (value: number) => value >= 0 || 'Anzahl muss höher 0 sein',
        loanMax: (value: number) => value <= 20 || 'Anzahl darf nicht höher 20 sein',
        integer: (value: number) => Number.isInteger(Number(value)) || 'Bitte nur Ganzzahlen eingeben'
    }
    private open: boolean = false;
    private anzahl: number = 1;
    private callback: any = undefined;

    public async show(callback: any): Promise<void> {
        this.callback = callback;
        this.open = true;
    }

    private close(): void {
        this.callback = () => {
        };
        this.anzahl = 1;
        this.open = false;
    }

    private save() {
        if (this.valid) {
            this.callback(this.anzahl);
            this.close();
        }
    }
}
</script>

<style>

</style>
